import { inject } from 'vue'
import type { Platform } from '@/enums/Platform'

export function usePlatform(): Platform {
  const platform = inject<Platform>('platform')

  if (!platform) {
    throw new Error('Platform is not defined')
  }

  return platform
}
